import { render, staticRenderFns } from "./ExceptionEdit.vue?vue&type=template&id=4a50b64d&scoped=true&"
import script from "./ExceptionEdit.vue?vue&type=script&lang=js&"
export * from "./ExceptionEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionEdit.vue?vue&type=style&index=0&id=4a50b64d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50b64d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
